import { useParams } from '@tanstack/react-router';
import { Card, CardContent } from '@/components/ui/Card.js';

/**
 * Catch-all plugin page. Phase 4 wires this to dynamic-import the plugin's UI
 * module — for now it renders a placeholder so the route is reachable from the
 * sidebar and the nav doesn't 404.
 */
export function PluginPage(): JSX.Element {
  const { pluginId, _splat } = useParams({ strict: false }) as { pluginId: string; _splat?: string };
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight capitalize">{pluginId}</h1>
        <p className="text-sm text-muted-foreground">
          Plugin UI dispatcher placeholder. Loaded module: <code className="rounded bg-muted px-1 py-0.5 font-mono text-xs">@deployit/plugin-{pluginId}</code>
        </p>
      </header>
      <Card>
        <CardContent className="py-12 text-center text-sm text-muted-foreground">
          Plugin component dispatch lands in Phase 4.
          {_splat ? <div className="mt-2 text-xs">Sub-path: <code className="font-mono">/{_splat}</code></div> : null}
        </CardContent>
      </Card>
    </div>
  );
}
